import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { API_ROUTES } from 'src/routes/api';

// ----------------------------------------------------------------------

export const MODAL_TYPE = {
  EDIT_COMMENT: 'editComment',
  EDIT_ANSWER: 'editAnswer'
};

const initialState = {
  isLoading: false,
  isLoaded: false,
  error: false,
  review: {},
  activeModal: {
    type: null,
    data: null
  }
};

const slice = createSlice({
  name: 'reviewDetails',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = false;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getReviewSuccess(state, action) {
      state.isLoading = false;
      state.isLoaded = true;
      state.review = action.payload;
    },
    clearReview(state) {
      state.review = {};
    },
    setActiveModal(state, action) {
      state.activeModal = {
        type: action.payload?.type || null,
        data: action.payload?.data || null
      };
    },
    reset(state) {
      Object.keys(state).forEach((key) => (state[key] = initialState[key]));
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { clearReview, setActiveModal } = slice.actions;

// ----------------------------------------------------------------------

export function getReviewDetails(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const {
        data: { review }
      } = await axios.get(API_ROUTES.reviews.byId(id));
      dispatch(slice.actions.getReviewSuccess(review));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function reset() {
  return async (dispatch) => {
    dispatch(slice.actions.reset());
  };
}
